import {AbstractDTO} from "@signature-it/ngx-generic/models";

export class CatalogueBlockDTO extends AbstractDTO {
    id: number;
    ngxComponent: string;
    name: string;
    ngxComponentPosition: number;
    ngxBoxSize: number;

    constructor(attributes: Object) {
        super(attributes);
        this.id = parseInt(attributes['id']) || -1;
        this.name = attributes['name'] || '';
        this.ngxComponent = attributes['ngx_component'] || '';
        this.ngxComponentPosition = attributes['ngx_component_position'] || 0;
        this.ngxBoxSize = attributes['ngx_box_size'] || 1;
    }
}
